/* */ 
"use strict";
var __extends = (this && this.__extends) || function(d, b) {
  for (var p in b)
    if (b.hasOwnProperty(p))
      d[p] = b[p];
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var lang_1 = require('../facade/lang');
var exceptions_1 = require('../facade/exceptions');
var async_1 = require('../facade/async');
var reflection_1 = require('../reflection/reflection');
var component_factory_1 = require('./component_factory');
var decorators_1 = require('../di/decorators');
var ComponentResolver = (function() {
  function ComponentResolver() {}
  return ComponentResolver;
}());
exports.ComponentResolver = ComponentResolver;
function _isComponentFactory(type) {
  return type instanceof component_factory_1.ComponentFactory;
}
var ReflectorComponentResolver = (function(_super) {
  __extends(ReflectorComponentResolver, _super);
  function ReflectorComponentResolver() {
    _super.apply(this, arguments);
  }
  ReflectorComponentResolver.prototype.resolveComponent = function(componentType) {
    var metadatas = reflection_1.reflector.annotations(componentType);
    var componentFactory = metadatas.find(_isComponentFactory);
    if (lang_1.isBlank(componentFactory)) {
      throw new exceptions_1.BaseException("No precompiled component " + lang_1.stringify(componentType) + " found");
    }
    return async_1.PromiseWrapper.resolve(componentFactory);
  };
  ReflectorComponentResolver.prototype.clearCache = function() {};
  ReflectorComponentResolver.decorators = [{type: decorators_1.Injectable}];
  return ReflectorComponentResolver;
}(ComponentResolver));
exports.ReflectorComponentResolver = ReflectorComponentResolver;
